import React from "react";
import { getStatusColor } from "../core/btw-status-colors";

const BtwStatusPill = ({ status, size = "md", className = "" }) => {
  if (!status) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700 ${className}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-gray-400" />
        Geen status
      </span>
    );
  }
  const colors = getStatusColor(status.color);
  const sizes =
    size === "sm"
      ? "px-2 py-0.5 text-[11px]"
      : size === "lg"
      ? "px-3 py-1 text-sm"
      : "px-2.5 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${colors.pill} ${sizes} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${colors.dot}`} />
      {status.name}
    </span>
  );
};

export default BtwStatusPill;
